var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker-erp',_vm._b({attrs:{"value":_vm._value,"placeholder":"选择日期时间"},on:{"change":_vm.onChange}},'date-picker-erp',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }